import { ChangeDetectionStrategy, Component, output, signal } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ModusButtonModule, ModusIconModule, ModusTooltipModule } from '@trimble-gcs/modus';
import { DownloadSelectListComponent } from './download-select-list/download-select-list.component';
import { downloadSelectTranslations } from './download-select.translations';

@UntilDestroy()
@Component({
  selector: 'sd-download-select',
  imports: [
    ModusTooltipModule,
    ModusButtonModule,
    ModusIconModule,
    DownloadSelectListComponent,
    MatProgressBarModule,
  ],
  templateUrl: './download-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DownloadSelectComponent {
  readonly translations = downloadSelectTranslations();
  readonly closeClicked = output();
  readonly showLoading = signal(false);

  setLoading(showLoading: boolean) {
    this.showLoading.set(showLoading);
  }
}
